module.exports = __webpack_public_path__ + "img/T2C_xs_00.ec0ca013.png";